import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "features/Header/Header";
import BackToTop from "components/BackToTop/BackToTop";
import Modal from "components/Modal/Modal";
import Footer from "features/Footer/Footer";
import "./Layout.scss";
import useBranding from "hooks/useBranding";
import WelcomeModal from "features/Welcome/WelcomeModal";
import Nps from "../features/Nps/Nps";
import Feedback from "../features/Feedback/Feedback";

const Layout = () => {
	const location = useLocation();
	const { whitelabelled, colours } = useBranding();
	const [showWelcomeModal, setShowWelcomeModal] = useState(false);
	const [newUser, setNewUser] = useState(true);
	const [showNps, setShowNps] = useState(false);
	const [isSpoofing, setIsSpoofing] = useState(false);
	const [isPreviewing, setIsPreviewing] = useState(false);

	const isElevatedView = isSpoofing || isPreviewing; // Elevated stands for both spoofing and preview mode combined. 

	useEffect(() => {
		const firstLogin = sessionStorage.getItem('firstLogin') === 'true';
		setNewUser(firstLogin);
		const showWelcome = sessionStorage.getItem('showWelcome') === 'true';
		setShowWelcomeModal(showWelcome);
		setIsSpoofing(sessionStorage.getItem('authSpoofer') !== null);
	}, []);

	useEffect(() => {
		setIsPreviewing(location.pathname === "/course-preview");
	}, [location]);

	useEffect(() => {
		const showNps = sessionStorage.getItem('nps') === 'true';
		setShowNps(showNps);
	}, [location]);

	const handleCloseWelcomeModal = () => {
		setShowWelcomeModal(false);
	};

	const rootStyle = () => {
		if (colours.Primary) {
			return (
				<style>
					{`:root {
							--primary-custom-color: ${colours.Primary};
							--secondary-custom-color: ${colours.Secondary};
							--text-on-primary-custom-color: ${colours.TextOnPrimary || '#FFFFFF'};
					}`}
				</style>
			);
		}
		return null;
	};

	// List of paths where the footer should be hidden
	const hideFooter = location.pathname === "/player";

	// List of paths where the header should be in wide form
	const wideHeader = location.pathname === "/player";

	// Hide BackToTop when the first path segment is "player"
	const hideBackToTop = location.pathname === "/player";

	return (
		<div className="layout-container">
			{rootStyle()}
			{showWelcomeModal && <WelcomeModal onClose={handleCloseWelcomeModal} newUser={newUser} />}
			<Header wideHeader={wideHeader} />
			<div className="content">
				<Outlet />
			</div>
			{!hideBackToTop && <BackToTop />}
			<Modal />
			{location.pathname === "/dashboard" && <Nps isVisible={showNps} />}
			<Footer hideFooter={hideFooter} whitelabelled={whitelabelled} />
			{!isElevatedView && <Feedback />}
			{isElevatedView && <div className="elevated-overlay"></div>}
		</div>
	);
};

export default Layout;
